// ADDED
import { useState, useCallback, useEffect } from "react";
import salaryAdvanceAccessService from "../services/salaryAdvanceAccessService";
import { SetAuditTrailBulk } from "../../components/Reports/AuditTrailReportEmployeeSetup";
import { useGeneralMessage } from "../../common/APICommon";

export const useSalaryAdvanceAccess = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const { showGeneralMessage, showMessage, message, isSuccess } = useGeneralMessage();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await salaryAdvanceAccessService.getAll();
      const responseData = res.data || [];
      setData(responseData);
      setFilterData(responseData);
    } catch (err) {
      console.error("Failed to fetch salary advance access data", err);
      showGeneralMessage("Failed to load access templates", false);
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateAccess = async (id, payload, auditData) => {
    setLoading(true);
    try {
      await salaryAdvanceAccessService.update(id, payload);
      
      if (auditData && auditData.length > 0) {
        await SetAuditTrailBulk({ data: auditData });
      }

      showGeneralMessage("Access updated successfully", true);
      await fetchData();
      return { success: true };
    } catch (err) {
      const errorMsg = err.response?.data?.message || "Failed to update access";
      showGeneralMessage(errorMsg, false);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  const searchData = (value) => {
    if (!value) {
      setData(filterData);
      return;
    }
    const lower = value.toLowerCase();
    setData(filterData.filter(f =>
      f.description?.toLowerCase().includes(lower) ||
      f.id?.toString().includes(lower)
    ));
  };

  return {
    loading,
    data,
    showMessage,
    message,
    isSuccess,
    searchData,
    updateAccess,
    refresh: fetchData
  };
};